<template>
 <div style="margin: 10px; background-color: white; position:relative;">
    <form role="form">
        <div class="container-fluid shadow">
            <div class="row">
                <div class="row">
                    <div class="col-md-12">
                        <div class="col-sm-12">
                            <h3><label class="text-left" >{{historyOrderLbl}}</label></h3>
                        </div>
                        <div class="row">
                            <div class="col-md-12"><span >&nbsp;</span></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 text-left">
                                <label class="text-left">{{$Jed.firstUpperTranslate("orders of clients")}}: {{$Jed.firstUpperTranslate("row") + ' ' + currentRow + ' ' + $Jed.translate("of") + ' ' + maxRows}}</label>
                            </div>
                            <div class="col-md-3 text-left">
                                <label class="text-left"></label>
                            </div>
                            <div class="col-md-3 text-left">
                                <label class="text-left"></label>
                            </div>
                            <div class="col-md-2 text-left">
                                <label class="text-left"></label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div style="display: inline-block; border-top: 1px solid lightgray; content: ''; top: 20px; right: 10em; vertical-align: top; bottom: 0; width: 100%;"> </div>
                            </div>                          
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div style="padding: 5px;">                                   
                                        <grid :columns="gridProdAttributesCfg.columns"
                                         :source.sync="arrayToTable" :options="options" :others="others"
                                                :lang="$root.token.idLingua" :name="gridProdAttributesCfg.title" :rowClick="rowClicked">
                                        </grid>               
                                    </div>
                                </div>
                            </div>
                        </div>                       
                    </div>
                </div>
            </div>
        </div>
    </form>
    </div>
</template>

<script>
import Grid from '../../dynamic/jqwGridWrapper/jqwGridWrapper.vue'
import InputW from '../../dynamic/inputWrapper/inputWrapper.vue'
import FormMixin from '../../dynamic/inputWrapper/formMixin.js'
import DynTableWrapper from "../../dynamic/DynTableWrapper.vue";
import table_resize_mixin from "../../../mixins/table_resize_mixin.js";
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import { eventBus } from "../../../eventbus";

export default {
    mixins: [FormMixin],
    components: {
        Grid,
        InputW,
        DynTableWrapper,
        vSelect
    },     
    data: function () {
        var vm = this;
        return {
            arrayToTable: [],
            currentRow: 0,
            maxRows: 0,
            historyOrderLbl: vm.$Jed.firstUpperTranslate("orders history"),
            APIGridShopCart: null,

            options: {
                    columnsresize: true,
                    columnsreorder: true,
                    columnsmenu: vm.$Components.TabellaOrdini.options.columnsmenu,
                    rowsheight: 24,
                    theme: "light",
                    width: "100%",
                    selectionmode: "none",
                    pageable: true,
                    showfilterrow: false,
                    filterable: true,
                    sortable: true,
                    ready: function(){
                        $("#TabellaOrdini").jqxGrid('sortby', 'data', 'desc');
                    },
                    pageable: false,
                    autoheight: false,
                    height: "402px",
                    rowdetails: true,
                    rowdetailstemplate: {
                        rowdetails:
                            "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
                        rowdetailsheight: 250 /* ! 230 + 20 ! */
                    },
                    /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
                    ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
                    initrowdetails: "nested",
                    rendered: null
            },
            others:{
                adaptColumns: true
            },
            gridProdAttributesCfg: {
                    ID: "gridProdAttributesId",
                    title: "TabellaOrdini",
                    label_title: "",
                    visible: true,
                    columns: {
                    configs:{
                        col1: {
                            text: "",
                            position: 1,
                            width: "3%", 
                            searchable: false,
                            filterable: false,
                            sortable: false,
                            align: "center",
                            datafield: "image",
                            cellsrenderer: function (data_row, datafield, value) {
                                return '<i class=' + vm.$root.icons.book +'"></i>';
                            },
                            onclick: function(obj) {
                                console.log(obj);
                                if(!vm.$root.shopCartData || obj.code != vm.$root.shopCartData.riferimento){
                                    vm.$router.push({
                                        name: "OrderDetail",
                                        params: { id: obj.refObj.ordId }
                                    });
                                }else{
                                    eventBus.$emit("alert", {type: "error", message: vm.$Jed.firstUpperTranslate("complete this order from cart before")+' - id: '+obj.refObj.ordId });
                                }
                            }
                        },
                        col2: {
                            text: "",
                            position: 2,
                            visible: true,
                            editable: false,
                            width: "3%",
                            searchable: false,
                            sortable: true,
                            datafield: "col2",
                            cellsrenderer: function (data_row, datafield, value) {
                                //è possibile caricare l’ordine nel carrello solo se ope = true (ovvero l'ordine è in stato di default apertura)
                                //se ope = false il pulsante non è visibile; 
                                var data_row = vm.arrayToTable[data_row].refObj
                                if( data_row.orderStatus && data_row.orderStatus.ope){
                                    return '<i class=' + vm.$root.icons.cart +'"></i>';
                                }
                            },
                            onclick: function(obj) {
                                console.log(obj);
                                //è possibile caricare l’ordine nel carrello solo se ope = true (ovvero l'ordine è in stato di default apertura)
                                var i = vm.arrayToTable.findIndex(x => x.code == obj.code)
                                var objInArray = vm.arrayToTable[i]
                                if( objInArray.refObj.orderStatus && objInArray.refObj.orderStatus.ope) {
                                    
                                    if(vm.$root.shopCartData && vm.$root.shopCartData.prodotti && vm.$root.shopCartData.prodotti.length > 0) {
                                        eventBus.$emit("alert", {type: "error", message: vm.$Jed.firstUpperTranslate("an order is already in cart")+' - id: '+vm.$root.shopCartData.id});
                                    }else {
                                        vm.$router.push({
                                            name: "ShopCart",
                                            params: { id: objInArray.refObj.ordId }
                                        });
                                    }
                                }
                            }

                        },
                        tipo: {
                            text: "order type",
                            position: 3,
                            visible: true,
                            editable: false,
                            width: vm.$root.token.hidePrices ? "14%" : "7%",
                            searchable: false,
                            sorting: true,
                            datafield: "tipo"
                        },
                        code: {
                            text: "id",
                            position: 4,
                            visible: true,
                            editable: false,
                            type: 'int',
                            width: "5%",
                            searchable: false,
                            sorting: true,
                            datafield: "code"
                        },
                        numordcli: {
                            text: "client order number",
                            position: 5,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "numord"
                        },
                        valuta: {
                            text: "currency",
                            position: 6,
                            visible: true,
                            editable: false,
                            width: "7%",
                            searchable: false,
                            sorting: true,
                            datafield: "val"
                        },
                        user: {
                            text: "user",
                            position: 7,
                            visible: true,
                            editable: false,
                            width: "15%",   
                            searchable: false,
                            sorting: true,
                            datafield: "user"
                        },
                        status: {
                            text: "order state",
                            position: 8,
                            visible: true,
                            editable: false,
                            width: "13%",   
                            searchable: false,
                            sorting: true,
                            datafield: "status"
                        },
                        data: {
                            text: "order date",
                            position: 9,
                            visible: true,
                            editable: false,
                            type: 'date',
                            width: "10%",   
                            searchable: false,
                            sorting: true,
                            datafield: "data"
                        },
                        conf: {
                            text: "confirm date",
                            position: 12,
                            visible: true,
                            editable: false,
                            type: 'date',
                            width: "10%",   
                            searchable: false,
                            sorting: true,
                            datafield: "conf"
                        },
                        consegna: {
                            text: "requested delivery date",
                            position: 10,
                            visible: true,
                            editable: false,
                            type: 'date',
                            width: "10%",   
                            searchable: false,
                            sorting: true,
                            datafield: "consegna"
                        },
                        totale: {
                            text: "order total",
                            position: 11,
                            visible: true,
                            hidden: vm.$root.token.hidePrices,
                            editable: false,
                            width: "7%",   
                            searchable: false,
                            sorting: true,
                            datafield: "tot",
                            cellsrenderer: function (data_row, datafield, value) {
                                return Number(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }
                        }
                    }
                }
            },          
        }
    },
    created:  function()  {
        var vm = this;

        eventBus.$on("gotChanges",()=>{
            vm.refreshGrid()
        })
    },
    mounted: function() {
        this.$nextTick(function(){
            this.refreshGrid();
        })
    },
    methods: {
        updateData(data ) {
            this.refreshGrid();
        },
        refreshGrid() {
            this.arrayToTable = [];
            var orders = this.$root.getOrders(),
                options = { month: '2-digit', day: '2-digit', year: 'numeric' };
            
            this.maxRows = orders ? orders.length : 0;
            if( this.maxRows > 0 ){
                this.currentRow = 1;
                for(var i = 0; i <orders.length; i++){       
                    var elem = orders[i];
                    
                    //TODO: a posteriori, se sync da errore o non viene fatta, 
                        //nel db locale mettere lo stato iniziale se id negativo
                    /*if(elem.id<0){
                        var reg_orders = this.$root.dbRegistry.getCollection('orders'),
                        reg_orderStatus = this.$root.dbRegistry.getCollection('orderStatuses'),
                        order = reg_orders.findOne({  'id': this.idValue  }),
                        orderStatus = reg_orderStatus.findOne({ 'id': order.osi });
                    }*/

                    this.arrayToTable.push({
                        refObj: elem,
                        tipo: elem.tipoOrdine,
                        code: elem.ordId,
                        numord: elem.numOrdineCli,
                        val: elem.valutaOrdine,
                        user: elem.userId,
                        status: elem.statoOrdine,
                        data: elem.dataOrdine != null ? new Date(elem.dataOrdine).toLocaleString('it-IT', options) : '',
                        consegna: elem.consegnaRichiesta ? new Date(elem.consegnaRichiesta).toLocaleString('it-IT', options) : '',
                        tot: elem.totaleOrdine,
                        conf: elem.orderStatus && elem.orderStatus.clo ? Date.now() : ''
                    })
                }   
            }else{
                console.log('righe ordine non pronte: ',this.maxRows.length)
                //ritorno alla pagina precedente
				this.$router.go(-1);
            }            
        },
        rowClicked(obj, index){
            this.currentRow = this.maxRows - index;
        }
    }
}
</script>

<style>

.v-select .dropdown-toggle {
    display: flex !important;
    flex-wrap: wrap;
}

.v-select input[type=search], .v-select input[type=search]:focus {
    flex-basis: 20px;
    flex-grow: 1;
    height: 28px;
    padding: 0 20px 0 10px;
    width: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/OrdersArchive.vue?47b14f2d